export default {
  apiUrl: process.env.REACT_APP_GRAPHQL_API_URL as string,
}
